import { render, staticRenderFns } from "./ForumResponseSaveButton.vue?vue&type=template&id=1e630d52&scoped=true"
import script from "./ForumResponseSaveButton.vue?vue&type=script&lang=js"
export * from "./ForumResponseSaveButton.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseSaveButton.vue?vue&type=style&index=0&id=1e630d52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e630d52",
  null
  
)

export default component.exports